import {Avatar} from '@sollapay/ui/components';

import {getInitials} from '@/utils/get-initials.utils';

import {memberDisplayName} from '../utils';

import type {TeamPerson} from '../types';
import type {ComponentProps, FC} from 'react';

export interface MemberAvatarProps {
  user: TeamPerson;
  size: ComponentProps<typeof Avatar>['size'];
}

export const MemberAvatar: FC<MemberAvatarProps> = ({user, size}) => (
  <Avatar
    initials={getInitials(memberDisplayName(user))}
    src={user.picture}
    size={size}
    seed={user.userId}
    noShadow
  />
);
